import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { RoutePermissionGuard } from '@/components/molecules';
import { ContactFormPanel } from '@/components/organisms/contacts/ContactFormPanel';

export const Route = createFileRoute('/_dashboard/dashboard/contacts/new')({
  validateSearch: (search: Record<string, unknown>): { parentContactId?: string } => ({
    parentContactId:
      typeof search.parentContactId === 'string' ? search.parentContactId : undefined,
  }),
  component: NewContactPage,
});

function NewContactPage() {
  const navigate = useNavigate();
  const { parentContactId } = Route.useSearch();

  return (
    <RoutePermissionGuard
      permissions="contacts:create"
      message="You do not have permission to create contacts."
    >
      <ContactFormPanel
        mode="create"
        initialParentContactId={parentContactId}
        onCancel={() => navigate({ to: '/dashboard/contacts' })}
        onSaved={(contact) =>
          navigate({
            to: '/dashboard/contacts/$contactId',
            params: { contactId: contact.id },
          })
        }
        onOpenExisting={(contactId) =>
          navigate({
            to: '/dashboard/contacts/$contactId',
            params: { contactId },
          })
        }
      />
    </RoutePermissionGuard>
  );
}
